import classNames from 'classnames';
import React from 'react';
import './Heading.pcss';

export type HeadingProps = {
  className?: string;
  size: 1 | 2 | 3 | 4 | 5 | 6; // https://github.com/Microsoft/TypeScript/issues/15480
  text?: string;
  children?: React.ReactNode;
  isBold?: boolean;
  nowrap?: boolean;
  element?: 'span' | 'div';
  addMarginAbove?: boolean;
  onClick?: () => void;
};

export const Heading = ({
  className,
  size,
  text,
  isBold = true,
  element = 'div',
  children,
  addMarginAbove,
  nowrap,
  ...props
}: HeadingProps) => {
  const computedClassName = classNames(
    'c-heading',
    `c-heading--size-${size}`,
    className,
    {
      'c-heading-bold': isBold,
      'c-heading-with-margin-above': addMarginAbove,
      'c-heading-nowrap': nowrap,
    },
  );
  return React.createElement(
    element,
    { className: computedClassName, ...props },
    text || children,
  );
};
